





























import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, State, Getter } from 'vuex-class'
import { Country } from '@/modules/geo/types'
import { Prop } from 'vue-property-decorator'

/**
 * Selector de pais
 *
 * Muestra una lista de los paises registrados en la base de datos geográfica
 * de Artisan y permite seleccionar uno, si se añade la propiedad
 * multiple permitirá seleccionar más de un pais
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class CountrySelector extends Vue {

    @Prop({type: [Array, Object]})
    public value: Country | Country[]

    @Prop({default: false})
    public multiple: boolean

    @Prop({type: String, default: 'Selección de país'})
    public placeholder: string

    /**
     * Lista de paises
     */
    @Getter('geo/countries/alphabetically')
    public countries: Country[]

    /**
     * Acción para cargar los paises desde el servidor
     */
    @Action('geo/loadCountries')
    public loadContries: () => Country[]

    public loading = true

    public async created () {
        await this.loadContries()
        this.loading = false
    }
}
